import { QuestionSubTypeEnum, QuestionType } from '@/types/schema';

export const getCustomRatingLabels = (
  question: Pick<QuestionType, 'subType' | 'customRatingComponent'>,
) => {
  if (question.subType === QuestionSubTypeEnum.CustomRating) {
    return question.customRatingComponent?.ratingLabels;
  }
};
